import axios from 'axios';
import React, { useEffect, useCallback } from 'react';
import * as THREE from "three";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
import { Vpoints2Array } from "../shape/Adapter";
import { GetTrim3D } from '../shape/Trim';
import { AddIcon } from './formUtil';
// import { POLLING_INTERVAL1, POLLING_INTERVAL10 } from '../store/global';
import { toast } from 'react-toastify';
import * as helptext from './helptext';

const FormTrim2 = () => {
  const style = SideStyle();
  const trim = Param.Get("trim");
  const trim2 = Param.Get("trim2");
  const baseshape = Param.Get("baseshape");
  // const modify         = Param.Get("modify");
  const setParam = Param.Get("setParam");
  const setControl = Control.Get("setControl");
  // const meshSocketF11  = Control.Get("meshSocketF11");
  const meshSocketModify = Control.Get("meshSocketModify");
  const meshSocketModifyVtk = Control.Get("meshSocketModifyVtk");
  const SetCameraFront = Control.Get("SetCameraFront");
  const SetCameraFree = Control.Get("SetCameraFree");


  useEffect(() => {
    //SetCameraFront()
    SetCameraFree()
    toast('Modify upper surface and trim it');
    //setParam(s => {s.trim2.step = -1});
  }, []);

  useEffect(() => {
    // set upper trim si points
    const radius = trim2.trimSiRadiusMedialPosterior;
    const radius1 = 30;
    const extend = 100;

    const radiusCurve = new THREE.EllipseCurve(
      radius + trim2.trimSiX, baseshape.bbox.min.z + trim2.trimSiZ + radius, // ax, aY
      radius, radius,                             // xRadius, yRadius
      Math.PI, 1.5 * Math.PI,                       // aStartAngle, aEndAngle
      false,                                      // aClockwise
      0                                           // aRotation
    );

    const radiusCurve1 = new THREE.EllipseCurve(
      radius1 + trim2.trimSiX, baseshape.bbox.max.z + trim2.trimSiZ - radius1, // ax, aY
      radius1, radius1,                             // xRadius, yRadius
      0.7 * Math.PI, Math.PI,                       // aStartAngle, aEndAngle
      false,                                      // aClockwise
      0                                           // aRotation
    );

    const radiusCurvePoints = radiusCurve.getPoints(50);
    const radiusCurvePoints1 = radiusCurve1.getPoints(50);

    const ptTrimSi = [];
    // set points
    // p0
    ptTrimSi.push(new THREE.Vector3(radius1 + trim2.trimSiX + 90 + trim2.trimSiP0X, 0, baseshape.bbox.max.z + trim2.trimSiZ + 20 + trim2.trimSiP0Z))
    // p1
    ptTrimSi.push(new THREE.Vector3(radius1 + trim2.trimSiX + 60 + trim2.trimSiP1X, 0, baseshape.bbox.max.z + trim2.trimSiZ + 10 + trim2.trimSiP1Z))
    // p2
    ptTrimSi.push(new THREE.Vector3(radius1 + trim2.trimSiX + 30 + trim2.trimSiP2X, 0, baseshape.bbox.max.z + trim2.trimSiZ + trim2.trimSiP2Z))


    radiusCurvePoints1.forEach((v) => {
      ptTrimSi.push(new THREE.Vector3(v.x, 0, v.y + trim2.trimSiBottomZ));
    });
    ptTrimSi.push(new THREE.Vector3(trim2.trimSiX, 0, baseshape.bbox.max.z - radius))

    radiusCurvePoints.forEach((v) => {
      ptTrimSi.push(new THREE.Vector3(v.x, 0, v.y));
    });
    ptTrimSi.push(new THREE.Vector3(baseshape.bbox.max.x + extend, 0, baseshape.bbox.min.z + trim2.trimSiZ))




    setParam(s => { s.trim2.ptTrimSi = ptTrimSi });
  }, [trim2.trimSiX, trim2.trimSiZ, trim2.trimSiRadiusMedialPosterior, trim2.trimSiBottomZ, trim2.trimSiP0X, trim2.trimSiP0Z, trim2.trimSiP1X, trim2.trimSiP1Z, trim2.trimSiP2X, trim2.trimSiP2Z]);

  useEffect(() => {
    const points = [];
    let offset = 50;
    points.push(new THREE.Vector3(offset, trim2.trimMlP0Y, trim2.trimMlP0Z));
    points.push(new THREE.Vector3(offset, trim2.trimMlP1Y, trim2.trimMlP1Z));
    points.push(new THREE.Vector3(offset, trim2.trimMlP2Y, trim2.trimMlP2Z));
    points.push(new THREE.Vector3(offset, trim2.trimMlP3Y, trim2.trimMlP3Z));

    setParam(s => { s.trim2.ptTrimMl = points });
  }, [trim2.trimMlP0Y, trim2.trimMlP0Z, trim2.trimMlP1Y, trim2.trimMlP1Z, trim2.trimMlP2Y, trim2.trimMlP2Z, trim2.trimMlP2Y, trim2.trimMlP2Z, trim2.trimMlP3Y, trim2.trimMlP3Z]);

  useEffect(() => {
    const points = [];
    let offset = 0;
    points.push(new THREE.Vector3(trim2.trimApP0X, trim2.trimApP0Y, offset));
    points.push(new THREE.Vector3(trim2.trimApP1X, trim2.trimApP1Y, offset));
    points.push(new THREE.Vector3(trim2.trimApP2X, trim2.trimApP2Y, offset));
    points.push(new THREE.Vector3(trim2.trimApP3X, trim2.trimApP3Y, offset));
    points.push(new THREE.Vector3(trim2.trimApP4X, trim2.trimApP4Y, offset));

    setParam(s => { s.trim2.ptTrimAp = points });
  }, [trim2.trimApP0X, trim2.trimApP0Y, trim2.trimApP1X, trim2.trimApP1Y, trim2.trimApP2X, trim2.trimApP2Y, trim2.trimApP3X, trim2.trimApP3Y, trim2.trimApP4X, trim2.trimApP4Y]);

  const onClick = useCallback((val) => {
    setParam(s => { s.trim2.step = val });
    setParam(s => { s.trim2.idxPoint = -1 });

    if (val == 0) {
      toast('Trimming upper surface from SI direction.');
    } else if (val == 1) {
      toast('Trimming upper surface from ML direction.');
    } else if (val == 2) {
      toast('Trimming upper surface from AP direction.');
    } else if (val == 3) {
      toast('Trimming as 3D curve.');
    }
  });

  const onRunTrim = useCallback((val) => {
    console.log("onRunTrim")
    if (val == 0) {
      setParam(s => { s.trim2.runTrimSi = true });
    } else if (val == 1) {
      setParam(s => { s.trim2.runTrimMl = true });
    } else if (val == 2) {
      setParam(s => { s.trim2.runTrimAp = true });
    } else if (val == 3) {
      setParam(s => { s.trim2.runTrim3D = true });
    }
  });

  const onClearTrim = useCallback((val) => {
    console.log("onClearTrim")
    if (val == 0) {
      setParam(s => { s.trim2.runTrimSi = false });
    } else if (val == 1) {
      setParam(s => { s.trim2.runTrimMl = false });
    } else if (val == 2) {
      setParam(s => { s.trim2.runTrimAp = false });
    } else if (val == 3) {
      setParam(s => { s.trim2.runTrim3D = false });
    }
  });


  const onTrim = () => {
    console.log("onTrim");

    const trimPoints = Vpoints2Array(trim.vpt3D)

    /*
    const trimPoints =  [[-4.7, 27, 59],
                        [4.7, 30, 58],
                        [33, 40, 41],
                        [46, 50, 20],
                        [48, 40, -1],
                        [43, 15, -22],
                        [17, 0, -52],
                        [-5, -6, -56],
                        [-29, 0, -52],
                        [-57, 15, -22],
                        [-61, 40, -1],
                        [-54, 50, 20],
                        [-40, 40, 41],
                        [-18, 30, 58]]
    */

    // axios settings
    const url = process.env.REACT_APP_BACKEND_SERVER + "/api/trim";
    const data = {
      'socketVertices': meshSocketModifyVtk.vertices,
      'socketFaces': meshSocketModifyVtk.faces,
      'smooth': Number(trim.smooth),
      'nTrimPointsMod': Number(trim.nTrimPointsMod),
      'trimPoints': trimPoints,
    };
    const header = {
      headers: {
        'Content-Type': 'application/json',
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          console.log(socketFaces.length)
          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i + 1, i + nFace + 1);

            if (nFace == 3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace == 4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }
            i += nFace;
          }

          setParam(s => { s.trim.step = 2 });

          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };
          console.log(temp)
          setControl(s => { s.meshSocketTrimVtk = temp });

          temp = {
            vertices: vertices,
            faces: faces,
          };
          console.log(temp)
          setControl(s => { s.meshSocketTrim = temp });
        }
      })
      .catch(err => {
        console.log('error');
      });
  }




  const handleValue = (e) => {
    setParam(s => { s.trim2[e.target.name] = Number(e.target.value) });
  };

  const to3D = () => {
    //change Vector3(0, x, y) --> Vector2(x, y)
    var vpt = [];
    console.log(trim.vpt2D)
    console.log("to3d")
    trim.vpt2D.forEach(pt => {
      vpt.push(new THREE.Vector2(pt.y, pt.z));
    });

    // for marking
    var meshSocket = null;
    if (meshSocketModify) {
      const geometry = new THREE.BufferGeometry();
      const material = new THREE.MeshLambertMaterial();
      geometry.setFromPoints(meshSocketModify.vertices);
      geometry.setIndex(meshSocketModify.faces)
      geometry.rotateX(-Math.PI / 2, 0, 0)
      meshSocket = new THREE.Mesh(geometry, material);
      //meshSocket.rotation.x = -Math.PI / 2,0,0
    }

    const vpt3D = GetTrim3D(meshSocket, vpt);

    setParam(s => { s.trim.step = 1, s.trim.vpt3D = vpt3D });
  }
  const to2D = () => {
    setParam(s => { s.trim.step = 0, s.trim.mode = 0, s.trim.vpt3D = null });
  };
  const onClear = () => {
    // SetControl(s => {s.meshSocketF14 = null});
    setControl(s => { s.meshSocketTrim = null });
    setControl(s => { s.meshSocketTrimVtk = null });
    setParam(s => { s.trim.step = 1 });
  };
  const onMove = () => {
    setParam(s => { s.trim.mode = 0 });
  };
  const onDelete = () => {
    setParam(s => { s.trim.mode = 1 });
  };
  function getActive(val) {
    return (trim2.step === val)
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }
  function equalTo(step) {
    return (trim.step == step) ? false : true;
  }
  function moreThan(step) {
    return (trim.step >= step) ? false : true;
  }
  useEffect(() => {
    setControl(s => { s.flgLegClickable = false, s.flgSocketClickable = false });
  });


  return (
    <div className={style.outside}>

      <TextField
        id="filled-number"
        name='idxPoint'
        label="Point No."
        type="number"
        defaultValue={trim2.idxPoint}
        fullWidth
        onChange={handleValue}
        onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
        InputLabelProps={{
          style: { color: '#fff' },
          shrink: true,
        }}
        variant="standard"
        inputProps={{
          style: {
            color: "white",
            textAlign: "left"
          },
          min: -1,
          max: 13,
          step: 1
        }}
      />


      {(trim2.idxPoint === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p0X'
            label='Point0 move ML'
            type='number'
            defaultValue={trim2.p0X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P0X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P0X}
              //   title='Point0 move ML'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id="filled-number"
            name='p0Y'
            label="Point0 move SI"
            type="number"
            defaultValue={trim2.p0Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P0Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P0Y}
              //   title='Point0 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p1X'
            label='Point1 move ML'
            type='number'
            defaultValue={trim2.p1X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P1X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P1X}
              //   title='Point1 move ML'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p1Y'
            label='Point1 move SI'
            type='number'
            defaultValue={trim2.p1Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P1Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P1Y}
              //   title='Point1 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p2X'
            label='Point2 move ML'
            type='number'
            defaultValue={trim2.p2X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P2X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P2X}
              //   title='Point2 move ML'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p2Y'
            label='Point2 move SI'
            type='number'
            defaultValue={trim2.p2Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P2Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P2Y}
              //   title='Point2 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p3Y'
            label='Point3 SI'
            type='number'
            defaultValue={trim2.p3Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P3Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P3Y}
              //   title='Point3 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p3CenterVecAmplify'
            label='Point3 move to center'
            type='number'
            defaultValue={trim2.p3CenterVecAmplify}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P3CenterVecAmplify; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P3CenterVecAmplify}
              //   title='Point3 move to center'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 4) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p4Y'
            label='Point4 SI'
            type='number'
            defaultValue={trim2.p4Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P4Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P4Y}
              //   title='Point4 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 4) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p4CenterVecAmplify'
            label='Point4 move to center'
            type='number'
            defaultValue={trim2.p4CenterVecAmplify}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P4CenterVecAmplify; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P4CenterVecAmplify}
              //   title='Point4 move to center'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 5) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p5Y'
            label='Point5 SI'
            type='number'
            defaultValue={trim2.p5Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P5Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P5Y}
              //   title='Point5 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 5) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p5CenterVecAmplify'
            label='Point5 move to center'
            type='number'
            defaultValue={trim2.p5CenterVecAmplify}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P5CenterVecAmplify; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P5CenterVecAmplify}
              //   title='Point5 move to center'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 6) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p6Z'
            label='Point6 move AP'
            type='number'
            defaultValue={trim2.p6Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P6Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P6Z}
              //   title='Point6 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 6) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p6Y'
            label='Point6 move SI'
            type='number'
            defaultValue={trim2.p6Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P6Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P6Y}
              //   title='Point6 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 7) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p7Z'
            label='Point7 move AP'
            type='number'
            defaultValue={trim2.p7Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P7Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P7Z}
              //   title='Point7 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 7) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p7Y'
            label='Point7 move SI'
            type='number'
            defaultValue={trim2.p7Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P7Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P7Y}
              //   title='Point7 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 8) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p8Z'
            label='Point8 move AP'
            type='number'
            defaultValue={trim2.p8Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P8Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P8Z}
              //   title='Point8 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 8) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p8Y'
            label='Point8 move SI'
            type='number'
            defaultValue={trim2.p8Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P8Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P8Y}
              //   title='Point8 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 9) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p9Z'
            label='Point9 move AP'
            type='number'
            defaultValue={trim2.p9Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P9Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P9Z}
              //   title='Point9 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 9) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p9Y'
            label='Point9 move SI'
            type='number'
            defaultValue={trim2.p9Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P9Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P9Y}
              //   title='Point9 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 10) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p10Z'
            label='Point10 move AP'
            type='number'
            defaultValue={trim2.p10Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P10Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P10Z}
              //   title='Point10 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 10) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p10Y'
            label='Point10 move SI'
            type='number'
            defaultValue={trim2.p10Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P10Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P10Y}
              //   title='Point10 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 11) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p11Z'
            label='Point11 move AP'
            type='number'
            defaultValue={trim2.p11Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P11Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P11Z}
              //   title='Point11 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 11) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p11Y'
            label='Point11 move SI'
            type='number'
            defaultValue={trim2.p11Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P11Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P11Y}
              //   title='Point11 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.idxPoint === 12) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p12Z'
            label='Point12 move AP'
            type='number'
            defaultValue={trim2.p12Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P12Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P12Z}
              //   title='Point12 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 12) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p12Y'
            label='Point12 move SI'
            type='number'
            defaultValue={trim2.p12Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P12Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P12Y}
              //   title='Point12 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.idxPoint === 13) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p13Z'
            label='Point13 move AP'
            type='number'
            defaultValue={trim2.p13Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P13Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P13Z}
              //   title='Point13 move AP'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.idxPoint === 13) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='p13Y'
            label='Point13 move SI'
            type='number'
            defaultValue={trim2.p13Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2P13Y; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2P13Y}
              //   title='Point13 move SI'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }


      <div></div>


      <Grid container alignItems='center'>
        {/* Trimming curve */}
        <Grid item xs={12} className={style.subcategory}>Trimming</Grid>
        <Grid item xs={3}>
          <Button name='step' className={getActive(0)} onClick={() => onClick(0)} >Trim SI</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name='step' className={getActive(1)} onClick={() => onClick(1)} >Trim ML</Button>
        </Grid>
        {/*
        <Grid item xs={3}>
          <Button disabled={true} name='step' className={style.buttonSelected} onClick={() => onClick(2)} >Trim AP</Button>
        </Grid>
        <Grid item xs={3}>
          <Button disabled={true} name='step' className={style.buttonSelected} onClick={() => onClick(3)} >Trim 3D</Button>
        </Grid>
        */}
      </Grid>



      {/*///////////////////////////// Trimming curve SI /////////////////////////*/}
      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiX'
            label='Move ML'
            type='number'
            defaultValue={trim2.trimSiX}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiX; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiX}
              //   title='Move ML'
              //   // imgSrc='./static/ak/img/trim2TrimSiX.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiZ'
            label='Move AP'
            type='number'
            defaultValue={trim2.trimSiZ}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiZ; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiZ}
              //   title='Move AP'
              //   // imgSrc='./static/ak/img/trim2TrimSiX.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiRadiusMedialPosterior'
            label='Radius Medial Posterior'
            type='number'
            defaultValue={trim2.trimSiRadiusMedialPosterior}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext=''
              //   title='Move ML'
              //   // imgSrc='./static/ak/img/trim2TrimSiX.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: 10,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiBottomZ'
            label='Move bottom line'
            type='number'
            defaultValue={trim2.trimSiBottomZ}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiBottomZ; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiBottomZ}
              //   title='Move bottom line'
              //   // imgSrc='./static/ak/img/trim2TrimSiBottomZ.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -100,
              max: 100,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP0X'
            label='Point 0 move ML'
            type='number'
            defaultValue={trim2.trimSiP0X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP0X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP0X}
              //   title='Point 0 move ML'
              //   // imgSrc='./static/ak/img/trim2TrimSiP0X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP0Z'
            label='Point 0 move AP'
            type='number'
            defaultValue={trim2.trimSiP0Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP0Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP0Z}
              //   title='Point 0 move AP'
              //   // imgSrc='./static/ak/img/trim2TrimSiP0Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP1X'
            label='Point 1 move ML'
            type='number'
            defaultValue={trim2.trimSiP1X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP1X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP1X}
              //   title='Point 1 move ML'
              //   // imgSrc='./static/ak/img/trim2TrimSiP1X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP1Z'
            label='Point 1 move AP'
            type='number'
            defaultValue={trim2.trimSiP1Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP1Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP1Z}
              //   title='Point 1 move AP'
              //   // imgSrc='./static/ak/img/trim2TrimSiP1Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP2X'
            label='Point 2 move ML'
            type='number'
            defaultValue={trim2.trimSiP2X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP2X; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP2X}
              //   title='Point 2 move ML'
              //   // imgSrc='./static/ak/img/trim2TrimSiP2X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.step === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimSiP2Z'
            label='Point 2 move AP'
            type='number'
            defaultValue={trim2.trimSiP2Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimSiP2Z; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimSiP2Z}
              //   title='Point 2 move AP'
              //   // imgSrc='./static/ak/img/trim2TrimSiP2Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }


      {/*///////////////////////////// Trimming curve ML /////////////////////////*/}
      {(trim2.step === 1) &&
        <TextField
          id="filled-number"
          name='idxPointTrimMl'
          label="Point No."
          type="number"
          defaultValue={trim2.idxPointTrimMl}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            },
            min: 0,
            max: 3,
            step: 1
          }}
        />
      }


      {(trim2.step === 1) && (trim2.idxPointTrimMl === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP0Z'
            label='Point 0 move AP'
            type='number'
            defaultValue={trim2.trimMlP0Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP0Z; s.explanationImg = './static/ak/img/trim2TrimMlP0Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP0Z}
              //   title='Point 0 move AP'
              //   imgSrc='./static/ak/img/trim2TrimMlP0Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP0Y'
            label='Point 0 move SI'
            type='number'
            defaultValue={trim2.trimMlP0Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP0Y; s.explanationImg = './static/ak/img/trim2TrimMlP0Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP0Y}
              //   title='Point 0 move SI'
              //   imgSrc='./static/ak/img/trim2TrimMlP0Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP1Z'
            label='Point 1 move AP'
            type='number'
            defaultValue={trim2.trimMlP1Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP1Z; s.explanationImg = './static/ak/img/trim2TrimMlP1Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP1Z}
              //   title='Point 1 move AP'
              //   imgSrc='./static/ak/img/trim2TrimMlP1Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP1Y'
            label='Point 1 move SI'
            type='number'
            defaultValue={trim2.trimMlP1Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP1Y; s.explanationImg = './static/ak/img/trim2TrimMlP1Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP1Y}
              //   title='Point 1 move SI'
              //   imgSrc='./static/ak/img/trim2TrimMlP1Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }


      {(trim2.step === 1) && (trim2.idxPointTrimMl === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP2Z'
            label='Point 2 move AP'
            type='number'
            defaultValue={trim2.trimMlP2Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP2Z; s.explanationImg = './static/ak/img/trim2TrimMlP1Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP2Z}
              //   title='Point 2 move AP'
              //   imgSrc='./static/ak/img/trim2TrimMlP1Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP2Y'
            label='Point 2 move SI'
            type='number'
            defaultValue={trim2.trimMlP2Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP2Y; s.explanationImg = './static/ak/img/trim2TrimMlP1Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP2Y}
              //   title='Point 2 move SI'
              //   imgSrc='./static/ak/img/trim2TrimMlP1Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP3Z'
            label='Point 3 move AP'
            type='number'
            defaultValue={trim2.trimMlP3Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP3Z; s.explanationImg = './static/ak/img/trim2TrimMlP3Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP3Z}
              //   title='Point 3 move AP'
              //   imgSrc='./static/ak/img/trim2TrimMlP3Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 1) && (trim2.idxPointTrimMl === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimMlP3Y'
            label='Point 3 move SI'
            type='number'
            defaultValue={trim2.trimMlP3Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.trim2TrimMlP3Y; s.explanationImg = './static/ak/img/trim2TrimMlP3Z.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.trim2TrimMlP3Y}
              //   title='Point 3 move SI'
              //   imgSrc='./static/ak/img/trim2TrimMlP3Z.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {/*///////////////////////////// Trimming curve AP /////////////////////////*/}
      {(trim2.step === 2) &&
        <TextField
          id="filled-number"
          name='idxPointTrimAp'
          label="Point No."
          type="number"
          defaultValue={trim2.idxPointTrimAp}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            },
            min: 0,
            max: 4,
            step: 1
          }}
        />
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP0X'
            label='Point 0 move ML'
            type='number'
            defaultValue={trim2.trimApP0X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 0) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP0Y'
            label='Point 0 move SI'
            type='number'
            defaultValue={trim2.trimApP0Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP1X'
            label='Point 1 move ML'
            type='number'
            defaultValue={trim2.trimApP1X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 1) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP1Y'
            label='Point 1 move SI'
            type='number'
            defaultValue={trim2.trimApP1Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP2X'
            label='Point 2 move ML'
            type='number'
            defaultValue={trim2.trimApP2X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 2) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP2Y'
            label='Point 2 move SI'
            type='number'
            defaultValue={trim2.trimApP2Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP3X'
            label='Point 3 move ML'
            type='number'
            defaultValue={trim2.trimApP3X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 3) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP3Y'
            label='Point 3 move SI'
            type='number'
            defaultValue={trim2.trimApP3Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 4) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP4X'
            label='Point 4 move ML'
            type='number'
            defaultValue={trim2.trimApP4X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step === 2) && (trim2.idxPointTrimAp === 4) &&
        <Grid container spacing={1} alignItems='center'>
          <TextField
            id='filled-number'
            name='trimApP4Y'
            label='Point 4 move SI'
            type='number'
            defaultValue={trim2.trimApP4Y}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='' />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              },
              min: -500,
              max: 500,
              step: 1
            }}
          />
        </Grid>
      }

      {(trim2.step !== -1) &&
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Button name='step' className={style.button} onClick={() => onRunTrim(trim2.step)} >Run trimming</Button>
          </Grid>
          <Grid item xs={6}>
            <Button name='step' className={style.button} onClick={() => onClearTrim(trim2.step)} >Reset trimming</Button>
          </Grid>
        </Grid>
      }


    </div>
  );
}
export default FormTrim2;
